import React from "react";
import { useRouteMatch, Redirect, Route, Switch } from "react-router-dom";

import withAdminNavbar from "features/navbar/wrappers/withAdminNavbar";
import AnalyticsPage from "../screens/analytics";
import DeploymentsPage from "../screens/deployments";

const AdminDashboardRouter: React.FC = () => {
    const { path } = useRouteMatch();

    const defaultDisplay = () => {
        return <Redirect to={`${path}/analytics`} />;
    };

    return withAdminNavbar(
        <Switch>
            <Route exact path={path}>
                {defaultDisplay}
            </Route>
            <Route exact path={`${path}/analytics`}>
                <AnalyticsPage />
            </Route>
            <Route exact path={`${path}/deployments`}>
                <DeploymentsPage />
            </Route>
        </Switch>
    );
};

export default AdminDashboardRouter;
